module.exports = __webpack_public_path__ + "img/logs.da9582cd.svg";